export const Icon = () => {
  return null;
};

Icon.displayName = "Icon";
